import classNames from "classnames"
import React from "react"
import headerLogo from "../../graphics/HeaderLogo.svg"
import businessHeaderLogo from "../../graphics/BusinessHeaderLogo.svg"
import {Button} from "../../ui/Button/Button"
import styles from "./greetings.module.scss"
import {GreetingsModalType} from "../../slices/userGuideSlice"
import {useTranslation} from "react-i18next"

export interface GreetingsTemplate {
    Header: React.FC<{greetingsModalType?: GreetingsModalType}>
    Body: React.FC<{greetingsModalType: GreetingsModalType}>
    FooterActions: React.FC<FooterTemplateProps>
}

interface HeaderTemplateProps {
    title: string
    icon?: string
    isBusiness?: boolean
}

export const HeaderTemplate: React.FC<HeaderTemplateProps> = ({title, icon, isBusiness}) => {
    return (
        <div className={styles.header}>
            <img
                className={styles.header__logo}
                src={isBusiness ? businessHeaderLogo : headerLogo}
                alt={""}
            />
            <div className={styles.header__title}>
                {icon && <img src={icon} alt="" />} {title}
            </div>
        </div>
    )
}

interface BodyTemplateProps {
    title: string
    text: React.ReactNode
    disclaimer?: string
}

export const BodyTemplate: React.FC<BodyTemplateProps> = ({title, text, disclaimer}) => {
    return (
        <div className={styles.body}>
            <div className={styles.body__title}>{title}</div>
            <div className={styles.body__text}>{text}</div>
            {disclaimer && <div className={styles.body__disclaimer}>{disclaimer}</div>}
        </div>
    )
}

interface FooterTemplateProps {
    onClose: () => void
    openArticles?: () => void
}

export const FooterTemplate: React.FC<FooterTemplateProps> = ({onClose, openArticles}) => {
    const {t} = useTranslation("greetings")
    return (
        <div
            className={classNames(styles.footer, {
                [styles.centered]: !openArticles,
            })}
        >
            <Button onClick={onClose}>{t`greetings:got_it`}</Button>
            {openArticles && <Button onClick={openArticles}>{t`greetings:to_articles`}</Button>}
        </div>
    )
}
